import { useParams } from 'next/navigation';
import { useState } from 'react';
import {
  gtmPushNewsletterSubscription,
  gtmPushNewsletterUnSubscription,
} from 'modules/gtm/modules/sections/newsletter/newsletter';
import { useRouter } from 'modules/next/hooks';
import { AppRoutes } from 'modules/shop/routes';
import storageModule from 'modules/storage';
import {
  checkSubscription,
  subscribeToNewsLetter,
  unsubscribeFromNewsLetter,
} from 'commerce/shop/emarsys';

export const useNewsletter = (
  storage = storageModule,
  gtm = {
    gtmPushNewsletterSubscription,
    gtmPushNewsletterUnSubscription,
  },
  api = {
    subscribeToNewsLetter,
    unsubscribeFromNewsLetter,
    checkSubscription,
  },
) => {
  const { push } = useRouter();
  const { locale } = useParams();
  const [isSubscribed, setIsSubscribed] = useState(false);

  const decodeEmail = (encodedEmail?: string) => {
    if (!!encodedEmail) {
      try {
        return atob(decodeURIComponent(encodedEmail));
      } catch (err) {
        console.error(err);
        return '';
      }
    }
  };

  const subscribe = async (email: string, shouldRedirect?: boolean) => {
    storage.session.setItem('news_subscription_email', email);
    const response = await api.subscribeToNewsLetter(email, locale as string);

    gtm.gtmPushNewsletterSubscription();
    if (shouldRedirect) {
      push(AppRoutes.NEWSLETTER_SUCCESS);
    }
    return response;
  };

  const unsubscribe = async (email: string) => {
    storage.session.removeItem('news_subscription_email');
    const { error } = await api.unsubscribeFromNewsLetter(email);

    if (!error) {
      gtm.gtmPushNewsletterUnSubscription();
      push(AppRoutes.NEWSLETTER_UNSUBSCRIBE_SUCCESS);
    }
  };

  const checkIsSubscribed = async (email?: string) => {
    if (email) {
      const { response, error } = await api.checkSubscription(email);

      !error && setIsSubscribed(!!response?.data.result);
    } else {
      setIsSubscribed(false);
    }
  };

  return {
    isSubscribed,
    subscribe,
    unsubscribe,
    decodeEmail,
    checkIsSubscribed,
  };
};
